import { FlightData } from '../types'
import { Plane } from './plane'
import L from 'leaflet'

export class Flight {
  map: L.Map
  flights: FlightData[]
  plane: Plane

  constructor (map: L.Map, iconSize: number, speedUnit: 'M' | 'K' = 'K', showTooltip: boolean = true) {
    this.plane = new Plane(map, iconSize, speedUnit, showTooltip)
  }

  apply (flights: FlightData[]) {
    this.flights = flights
    this.plane.apply(flights)
  }

  startReplay () {
    this.plane.replay = true
    void this.plane.movePlaneAlongPath(this.flights)
  }

  stopReplay () {
    this.plane.replay = false
  }
}
